export default "__VITE_ASSET__B8QwdHp0__"